export const miraIcons = {
    'nav.today': {
        name: 'nav.today',
        viewBox: '0 0 24 24',
        primitives: [
            { kind: 'line', x1: 12, y1: 5.5, x2: 12, y2: 8.5 },
            { kind: 'line', x1: 12, y1: 15.5, x2: 12, y2: 18.5 },
            { kind: 'line', x1: 5.5, y1: 12, x2: 8.5, y2: 12 },
            { kind: 'line', x1: 15.5, y1: 12, x2: 18.5, y2: 12 },
            { kind: 'circle', cx: 12, cy: 12, r: 3.25 },
        ],
    },
    'nav.topics': {
        name: 'nav.topics',
        viewBox: '0 0 24 24',
        primitives: [
            { kind: 'path', d: 'M6.5 6.5h11' },
            { kind: 'path', d: 'M6.5 12h8.5' },
            { kind: 'path', d: 'M6.5 17.5h6' },
            { kind: 'path', d: 'M4.5 5.25v13.5' },
        ],
    },
    'nav.relationships': {
        name: 'nav.relationships',
        viewBox: '0 0 24 24',
        primitives: [
            { kind: 'circle', cx: 9, cy: 9, r: 3 },
            { kind: 'circle', cx: 16, cy: 14.5, r: 2.5 },
            { kind: 'path', d: 'M11.25 11.25l2.55 1.9' },
            { kind: 'path', d: 'M5.75 18.25c.7-2.25 2.1-3.4 4.25-3.4' },
        ],
    },
    'nav.memory': {
        name: 'nav.memory',
        viewBox: '0 0 24 24',
        primitives: [
            { kind: 'path', d: 'M7 5.75h8.5a2.5 2.5 0 0 1 2.5 2.5v9.25H8.5A2.5 2.5 0 0 1 6 15V6.75a1 1 0 0 1 1-1Z' },
            { kind: 'path', d: 'M9.5 9h5' },
            { kind: 'path', d: 'M9.5 12.5h4' },
        ],
    },
    'action.back': {
        name: 'action.back',
        viewBox: '0 0 24 24',
        primitives: [
            { kind: 'path', d: 'M15 5.5 8.5 12 15 18.5' },
        ],
    },
    'action.next': {
        name: 'action.next',
        viewBox: '0 0 24 24',
        primitives: [
            { kind: 'path', d: 'm9 5.5 6.5 6.5L9 18.5' },
        ],
    },
    'action.close': {
        name: 'action.close',
        viewBox: '0 0 24 24',
        primitives: [
            { kind: 'path', d: 'M7 7l10 10' },
            { kind: 'path', d: 'M17 7 7 17' },
        ],
    },
    'action.filter': {
        name: 'action.filter',
        viewBox: '0 0 24 24',
        primitives: [
            { kind: 'path', d: 'M5 7.5h14' },
            { kind: 'path', d: 'M8 12h8' },
            { kind: 'path', d: 'M10.5 16.5h3' },
        ],
    },
    'action.search': {
        name: 'action.search',
        viewBox: '0 0 24 24',
        primitives: [
            { kind: 'circle', cx: 10.7, cy: 10.7, r: 5.2 },
            { kind: 'path', d: 'm15 15 4 4' },
        ],
    },
    'action.add': {
        name: 'action.add',
        viewBox: '0 0 24 24',
        primitives: [
            { kind: 'path', d: 'M12 6v12' },
            { kind: 'path', d: 'M6 12h12' },
        ],
    },
    'action.edit': {
        name: 'action.edit',
        viewBox: '0 0 24 24',
        primitives: [
            { kind: 'path', d: 'M6.5 17.5 8 13.75 15.75 6l2.25 2.25L10.25 16 6.5 17.5Z' },
            { kind: 'path', d: 'M14.5 7.25 16.75 9.5' },
        ],
    },
    'action.logout': {
        name: 'action.logout',
        viewBox: '0 0 24 24',
        primitives: [
            { kind: 'path', d: 'M9 5.5H6.5v13H9' },
            { kind: 'path', d: 'M13.25 8 17 12l-3.75 4' },
            { kind: 'path', d: 'M16.5 12h-7' },
        ],
    },
    'action.check': {
        name: 'action.check',
        viewBox: '0 0 24 24',
        primitives: [
            { kind: 'path', d: 'm6.5 12.4 3.35 3.35 7.65-7.5' },
        ],
    },
    'action.send': {
        name: 'action.send',
        viewBox: '0 0 24 24',
        primitives: [
            { kind: 'path', d: 'M5 12.4 19 5.5l-4.6 13-3.1-5.6L5 12.4Z' },
            { kind: 'path', d: 'm11.3 12.9 3.4-3.2' },
        ],
    },
    'action.settings': {
        name: 'action.settings',
        viewBox: '0 0 24 24',
        primitives: [
            { kind: 'circle', cx: 12, cy: 8.5, r: 3.3 },
            { kind: 'path', d: 'M5.8 19.25c1.15-3.9 3.2-5.85 6.2-5.85s5.05 1.95 6.2 5.85' },
        ],
    },
    'action.delete': {
        name: 'action.delete',
        viewBox: '0 0 24 24',
        primitives: [
            { kind: 'path', d: 'M7 8h10' },
            { kind: 'path', d: 'M10 8V6.5h4V8' },
            { kind: 'path', d: 'M8.2 8.5l.7 10h6.2l.7-10' },
            { kind: 'path', d: 'M10.5 11.5v4' },
            { kind: 'path', d: 'M13.5 11.5v4' },
        ],
    },
    'action.microphone': {
        name: 'action.microphone',
        viewBox: '0 0 24 24',
        primitives: [
            { kind: 'path', d: 'M12 4.75v7.5' },
            { kind: 'path', d: 'M8.75 8.25a3.25 3.25 0 0 1 6.5 0v3.5a3.25 3.25 0 0 1-6.5 0v-3.5Z' },
            { kind: 'path', d: 'M6.25 11.5a5.75 5.75 0 0 0 11.5 0' },
            { kind: 'path', d: 'M12 17.25v2.25' },
        ],
    },
    'semantic.insight': {
        name: 'semantic.insight',
        viewBox: '0 0 24 24',
        primitives: [
            { kind: 'path', d: 'M12 3.75v3' },
            { kind: 'path', d: 'M12 17.25v3' },
            { kind: 'path', d: 'M4.75 12h3' },
            { kind: 'path', d: 'M16.25 12h3' },
            { kind: 'path', d: 'M8.4 8.4 6.3 6.3' },
            { kind: 'path', d: 'M15.6 15.6l2.1 2.1' },
            { kind: 'circle', cx: 12, cy: 12, r: 2.2 },
        ],
    },
    'semantic.lock': {
        name: 'semantic.lock',
        viewBox: '0 0 24 24',
        primitives: [
            { kind: 'path', d: 'M7.25 10.25h9.5v8h-9.5z' },
            { kind: 'path', d: 'M9 10.25V8.5a3 3 0 0 1 6 0v1.75' },
            { kind: 'circle', cx: 12, cy: 14.25, r: 1 },
        ],
    },
    'semantic.memory': {
        name: 'semantic.memory',
        viewBox: '0 0 24 24',
        primitives: [
            { kind: 'path', d: 'M7 5.75h8.5a2.5 2.5 0 0 1 2.5 2.5v9.25H8.5A2.5 2.5 0 0 1 6 15V6.75a1 1 0 0 1 1-1Z' },
            { kind: 'path', d: 'M9.5 9h5' },
            { kind: 'path', d: 'M9.5 12.5h4' },
        ],
    },
    'semantic.note': {
        name: 'semantic.note',
        viewBox: '0 0 24 24',
        primitives: [
            { kind: 'path', d: 'M7 5.5h10v13H7z' },
            { kind: 'path', d: 'M9.5 9h5' },
            { kind: 'path', d: 'M9.5 12h4.5' },
            { kind: 'path', d: 'M9.5 15h3' },
        ],
    },
    'semantic.relationship': {
        name: 'semantic.relationship',
        viewBox: '0 0 24 24',
        primitives: [
            { kind: 'circle', cx: 8.8, cy: 9.2, r: 2.8 },
            { kind: 'circle', cx: 15.6, cy: 10.8, r: 2.4 },
            { kind: 'path', d: 'M4.8 18.5c.8-2.5 2.35-3.75 4.6-3.75' },
            { kind: 'path', d: 'M13 15.3c2 .2 3.45 1.25 4.35 3.2' },
        ],
    },
    'semantic.spark': {
        name: 'semantic.spark',
        viewBox: '0 0 24 24',
        primitives: [
            { kind: 'path', d: 'M12 4.75c.6 3.2 2.05 5.05 5.25 5.65-3.2.6-4.65 2.45-5.25 5.65-.6-3.2-2.05-5.05-5.25-5.65 3.2-.6 4.65-2.45 5.25-5.65Z' },
        ],
    },
    'semantic.topic': {
        name: 'semantic.topic',
        viewBox: '0 0 24 24',
        primitives: [
            { kind: 'path', d: 'M6.5 6.5h11' },
            { kind: 'path', d: 'M6.5 12h8.5' },
            { kind: 'path', d: 'M6.5 17.5h6' },
            { kind: 'path', d: 'M4.5 5.25v13.5' },
        ],
    },
};
export const miraIconNames = Object.keys(miraIcons);
